<template>
  <q-dialog v-model="dialog" persistent>
    <div class="hris-modal hris-modal-lg" style="max-width: 980px; width: 100%;">
      <div class="hris-modal-header">
        <div>
          <h2 class="hris-modal-title">Mandatory Benefits Fund (MBF) Numbers</h2>
          <p class="hris-modal-subtitle">{{ fullname }}</p>
        </div>
        <q-btn flat dense round v-close-popup class="hris-q-ghost" aria-label="Close">
          <i class="fas fa-times"></i>
        </q-btn>
      </div>
      <div class="hris-modal-body">
        <q-form ref="vForm" @submit="onSubmit">
          <div class="row q-col-gutter-md">
            <div class="col-12 col-md-4">
              <div class="hris-form-section" style="margin-bottom: 0;">
                <div class="hris-form-section-title">Update Number</div>
                <div class="q-gutter-md">
                  <q-select outlined dense color="green" v-model="cardtype" option-value="val" :rules="[formRules.required]" option-label="name" :options="typeOptions" label="Type" emit-value map-options></q-select>
                  <q-input outlined dense color="green" v-model="cardNo" label="Card No." :rules="[formRules.required]" type="number"></q-input>
                  <q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <div class="hris-panel" style="margin-bottom: 0;">
                <div class="hris-panel-title">Update History</div>
                <q-table flat :data="MBF" :columns="columns" row-key="id">
                  <template v-slot:body="props">
                    <q-tr :props="props" @click="selectedRow(props)" style="cursor: pointer;">
                      <q-td key="cardtype" :props="props">{{ props.row.cardtype }}</q-td>
                      <q-td key="old" :props="props">{{ props.row.old }}</q-td>
                      <q-td key="new" :props="props">{{ props.row.new }}</q-td>
                      <q-td key="date_added" :props="props">{{ props.row.date_added }}</q-td>
                      <q-td key="updateby" :props="props">{{ props.row.updateby }}</q-td>
                    </q-tr>
                  </template>
                  <template v-slot:no-data="">
                    <div class="hris-empty full-width">No MBF update records found.</div>
                  </template>
                </q-table>
              </div>
            </div>
          </div>
        </q-form>
      </div>
    </div>
  </q-dialog>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

  data() {
    return {
      empID:0,
      dialog:false,
      cardtype:null,
      cardNo:null,
      date_added:null,
      updateby:null,
      fullname:null,
      columns: [
      { name: 'cardtype', align: 'center', label: 'Type', field: 'cardtype', sortable: true },
      { name: 'old', align: 'center', label: 'Old', field: 'old', sortable: true },
      { name: 'new', label: 'New', field: 'new', sortable: true },
      { name: 'date_added', label: 'Last Update', field: 'date_added' , sortable: true},
      { name: 'updateby', label: 'Update By', field: 'updateby' , sortable: true},
      ],
      MBF: [],
      typeOptions:[
      {val:'SSS',name:'SSS #'},
      {val:'TIN',name:'TIN #'},
      {val:'HDMF',name:'HDMF #'},
      {val:'PHIC',name:'PHIC #'},
      ],
    }
  },
  created(){
    this.eventHub.$on('MBFUpdate', this.MBFUpdate);
  },

  methods: {

    MBFUpdate:function(payload){
      this.fullname = payload.employee.row.firstname + ' ' + payload.employee.row.lastname + '' + ' MBF List'
      this.empID = payload.employee.row.id
      this.dialog = payload.stat
      this.getMBFUpdate(this.empID)
    },

    selectedRow:function(emp){
     this.cardtype = emp.row.cardtype
     this.cardNo = emp.row.new
   },


   onSubmit:function(){
    let formData = new FormData();

    formData.append("empID", this.empID);
    formData.append("cardtype", this.cardtype);
    formData.append("cardNo", this.cardNo);
    formData.append("updateby", this.userData.username);

    axios.create({
      baseURL : this.apiUrl,
      headers : {'Authorization' : `Bearer ${this.token}`}
    }).post('/admin/employee/mbf',formData)
    .then((res) => {
      console.log(res.data.data)
      this.getMBFUpdate(this.empID)
      this.cardtype = ''
      this.cardNo = ''
      this.$refs.vForm.reset()
    });
  },

  getMBFUpdate: function(empID) {
    axios.create({
      baseURL: this.apiUrl,
      headers: {
        'Authorization': `Bearer ${this.token}`
      }})
    .get(`/admin/employee/mbf/${empID}`)
    .then((res) => {
      this.MBF = res.data.data;
      setTimeout(() => {
        this.spinner = false
      },500)
    })

  },

  closeModal:function(){
    this.career = false
  },
}
}
</script>
<style lang="css" scoped>
</style>
